import b from 'b_';
import { Success } from 'education-icons';
import { Popup, SimpleCallback, Text } from 'platform-components';
import { POPUP_AXIS, POPUP_DIRECTIONS, POPUP_THEMES } from 'platform-components/constants';
import React, { useRef } from 'react';
import { accessibleClick, accessibleMouseHover } from '@edu-frontend/modules/src/shared/lib/a11y';

import './quiz-editor__answer-checkbox.scss';

interface Props {
    checked: boolean;
    onClick: SimpleCallback;
}

export const QuizEditorAnswerCheckbox = (props: Props) => {
    const { checked, onClick } = props;

    const tooltipRef = useRef<Popup>(null);

    const showTooltip = () => {
        tooltipRef?.current?.show();
    };

    const hideTooltip = () => {
        tooltipRef?.current?.hide();
    };

    const handleClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        event.stopPropagation();
        onClick();
    };

    const tooltipTextId = checked
        ? 'teacherLab.quizEditor.cardCheckbox.checkedMessage'
        : 'teacherLab.quizEditor.cardCheckbox.notCheckedMessage';

    return (
        <>
            <div
                className={b('quiz-editor__answer-checkbox', { checked })}
                {...accessibleClick(handleClick)}
                {...accessibleMouseHover({
                    onMouseEnter: showTooltip,
                    onMouseLeave: hideTooltip,
                    describedby: tooltipTextId,
                })}
            >
                <Success className="checkbox__icon" />
            </div>
            <Popup
                axis={POPUP_AXIS.START}
                direction={POPUP_DIRECTIONS.TOP}
                hasArrow
                offsetLeft={15}
                offsetTop={68}
                ref={tooltipRef}
                theme={POPUP_THEMES.DARK_ROUNDED}
                trackOwnerPosition
            >
                <Text className="checkbox__popup-text" id={tooltipTextId} />
            </Popup>
        </>
    );
};
